class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);StampedFn.loadBadges();
      $('.quick-add__submit').removeAttr('disabled')
      $('.quick-add__submit').removeAttr('disabled')
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);StampedFn.loadBadges();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);StampedFn.loadBadges();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);StampedFn.loadBadges();
      var total_count = $(".mobile_total_count").attr("data-count");
$(".append_mobile_total_count").html('('+total_count+')')
$('.quick-add__submit').removeAttr('disabled')
          var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    offset: 1000,
    callback: function() {
      $('.quick-add__submit').removeAttr('disabled');
    StampedFn.reloadUGC();
  }
  });
(function() {
  const productSelector = '[selecteditemparent]';
  const viewedItems = new Set(); // Track processed items
  const jsonObjMap = new Map(); // Map to collect item data by sectionId
  const visibleProducts = new Map(); // Track currently visible products
  let totalRequests = 0; // Total number of AJAX requests
  let completedRequests = 0; // Number of completed AJAX requests

  // Create an IntersectionObserver instance
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const productElement = entry.target;
      const productUrl = productElement.dataset.url;
      const sectionId = productElement.dataset.sectionid;
      const sectionname = productElement.dataset.sectionname;
      const datacategory = productElement.dataset.category;
      const productindex = parseInt(productElement.dataset.index, 10); // Ensure index is an integer
      if (entry.isIntersecting) {
        // Only fetch product data if it hasn't been fetched before
        if (!viewedItems.has(productUrl)) {
          // Mark this product as viewed
          viewedItems.add(productUrl);
          visibleProducts.set(productUrl, { sectionId }); // Track visible product

          // Increment totalRequests when a new request is initiated
          totalRequests++;
          // Fetch product data with AJAX using the URL
          fetchProductData(productUrl, sectionId, sectionname, productindex, datacategory);
        }
      } else {
        // If the product is no longer visible, remove from visibleProducts
        visibleProducts.delete(productUrl);
      }
    });
  }, { threshold: 0.5 }); // Adjust the threshold as needed

  // Observe each product element
  document.querySelectorAll(productSelector).forEach(product => {
    observer.observe(product);
  });

  function fetchProductData(productUrl, sectionId, sectionname, productindex, datacategory) {
    jQuery.ajax({
      type: 'GET',
      url: productUrl,
      dataType: 'json'
    }).then(function(productdata) {
      const jsonData = [];
   
      // Process product data
      const product = productdata.product;
      
      let variant_name = '';
      for (let i = 0; i < product.variants.length; i++) {
        variant_name += product.variants[i].title + ',';
      }
      const new_var_name = variant_name.slice(0, -1).trim();
      const main_price = parseInt(product.variants[0].price, 10);
      const compare_main_price = parseInt(product.variants[0].compare_at_price, 10);
      let discount_exist = 'NA';
      if (compare_main_price > main_price) {
        const discount_exist_2 = compare_main_price - main_price;
        discount_exist = "₹" + discount_exist_2.toString();
      }
      jsonData.push({
        item_id: product.id,
        item_name: product.title,
        coupon: "NA",
        discount: discount_exist,
        index: productindex,
        item_brand: product.vendor,
        item_list_id: sectionId,
        item_list_name: sectionname,
        item_category: datacategory,
        item_category2: product.product_type,
        item_variant: new_var_name,
        price: main_price,
        quantity: "1"
      });

      // Add the results to the map by sectionId
      if (!jsonObjMap.has(sectionId)) {
        jsonObjMap.set(sectionId, []);
      }
      jsonObjMap.get(sectionId).push(...jsonData);

      completedRequests++;
      
      // Push to dataLayer only when all visible products are processed
      if (completedRequests === visibleProducts.size && visibleProducts.size > 0) {
        window.dataLayer = window.dataLayer || [];
        
        // Sort and push items for each sectionId
        jsonObjMap.forEach((items, sectionId) => {
          // Sort items by productindex
          items.sort((a, b) => a.index - b.index);

          window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
              item_list_id: sectionId, // Use sectionId for item_list_id
              item_list_name: sectionname, // Use sectionId for item_list_name
              items: items
            }
          });
        });

        // Clear the map and reset counts for the next batch of requests
        jsonObjMap.clear();
        completedRequests = 0; // Reset completedRequests for the next batch
        visibleProducts.clear(); // Optionally, clear the visibleProducts if needed
      }
    }).fail(function(xhr, status, error) {
      console.error('Error fetching product data:', {
        url: productUrl,
        status: status,
        error: error,
        responseText: xhr.responseText
      });
    });
  }
})();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);StampedFn.loadBadges();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');StampedFn.loadBadges();
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));StampedFn.loadBadges();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
     
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();StampedFn.loadBadges();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));StampedFn.loadBadges();
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));StampedFn.loadBadges();
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);StampedFn.loadBadges();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);StampedFn.loadBadges();
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);StampedFn.loadBadges();
  }
}

customElements.define('facet-remove', FacetRemove);
